import React from 'react'
import { ExternalLink, Info } from 'lucide-react'
import { Popover } from '@cannect/new-components/atoms'
import { cn } from '@cannect/lib/utils'

/**
 * Ícone de informação sobre a Curadoria Técnica, com link para a /curadoria.
 *
 * Usa Popover e não Tooltip de propósito: o Radix Tooltip fecha quando o ponteiro
 * sai do gatilho, o que deixaria o "Saiba mais" praticamente inclicável.
 * Espelha o componente equivalente do assistant-cannect.
 */
export const CuratorshipInfo: React.FC<{ className?: string }> = ({ className }) => (
  <Popover.Root>
    <Popover.Trigger asChild>
      <button
        type="button"
        aria-label="O que é a Curadoria Técnica de Produtos"
        className={cn(
          'inline-flex cursor-pointer items-center border-none bg-transparent p-0 text-neutral-400 transition-colors hover:text-primary-700',
          className
        )}>
        <Info className="size-4" />
      </button>
    </Popover.Trigger>

    <Popover.Content align="start" side="bottom" className="w-80 space-y-3">
      <p className="text-sm font-semibold text-[#433f3e]">Curadoria Técnica de Produtos</p>

      <p className="text-xs leading-relaxed text-neutral-600">
        O percentual reflete a aderência do produto ao conjunto de critérios técnicos avaliados pela Curadoria, dos
        certificados da marca à embalagem final.
      </p>

      <a
        href="/curadoria"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs font-semibold text-primary-700 hover:underline">
        Saiba mais
        <ExternalLink className="size-3" />
      </a>
    </Popover.Content>
  </Popover.Root>
)

export default CuratorshipInfo
